import firebase from 'firebase/app'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyCEgKH_-H_s8kqDN85iyPgMu63dOD9z4R8',
  authDomain: 'cs-form-2ee6f.firebaseapp.com',
  databaseURL: 'https://cs-form-2ee6f.firebaseio.com',
  projectId: 'cs-form-2ee6f',
  storageBucket: 'cs-form-2ee6f.appspot.com',
  messagingSenderId: '571479995991',
  appId: '1:571479995991:web:2b032698bdf35540a15512'
}

firebase.initializeApp(firebaseConfig)
const storageRef = firebase.storage().ref()

export default storageRef
